/* eslint-disable */
export const printData = {
	table: [ {
		"goods_name" : "熊猫女士T恤",
		"goods_code" : "WPDSX01016",
		"goods_barcode" : "WPDSX010163635",
		"goods_tags_json" : "[\"2019\"]",
		"location_name" : "上海万体馆",
		"size_name" : "xxl36",
		"color_name" : "红色35",
		"qty" : 9
	  }, {
		"goods_name" : "熊猫女士T恤",
		"goods_code" : "WPDSX01016",
		"goods_barcode" : "WPDSX010163637",
		"goods_tags_json" : "[\"2019\"]",
		"location_name" : "上海万体馆",
		"size_name" : "xxl36",
		"color_name" : "红色37",
		"qty" : 9
	  }, {
		"goods_name" : "熊猫女士T恤",
		"goods_code" : "WPDSX01016",
		"goods_barcode" : "WPDSX010163651",
		"goods_tags_json" : "[\"2019\"]",
		"location_name" : "上海万体馆",
		"size_name" : "xxl36",
		"color_name" : "红色51",
		"qty" : 9
	  }, {
		"goods_name" : "0729LY测试商品（第四个）",
		"goods_code" : "LY2234677",
		"goods_barcode" : "LY22346773637",
		"goods_tags_json" : "[\"2019\"]",
		"location_name" : "上海万体馆",
		"size_name" : "xxl36",
		"color_name" : "红色37",
		"qty" : 35
	  }, {
		"goods_name" : "0729LY测试商品（第四个）",
		"goods_code" : "LY2234677",
		"goods_barcode" : "LY22346773637",
		"goods_tags_json" : "[\"2019\"]",
		"location_name" : "库位",
		"size_name" : "xxl36",
		"color_name" : "红色37",
		"qty" : -10
	  }, {
		"goods_name" : "0729LY测试商品（第四个）",
		"goods_code" : "LY2234677",
		"goods_barcode" : "LY22346774050",
		"goods_tags_json" : "[\"2019\"]",
		"location_name" : "上海万体馆",
		"size_name" : "xl40",
		"color_name" : "红色50",
		"qty" : 10
	  }, {
		"goods_name" : "0729LY测试商品（第四个）",
		"goods_code" : "LY2234677",
		"goods_barcode" : "LY22346774051",
		"goods_tags_json" : "[\"2019\"]",
		"location_name" : "上海万体馆",
		"size_name" : "xl40",
		"color_name" : "红色51",
		"qty" : 10
	  }, {
		"goods_name" : "0729LY测试商品（第四个）",
		"goods_code" : "LY2234677",
		"goods_barcode" : "LY22346774052",
		"goods_tags_json" : "[\"2019\"]",
		"location_name" : "上海万体馆",
		"size_name" : "xl40",
		"color_name" : "红色52",
		"qty" : 10
	  }, {
		"goods_name" : "0729LY测试商品（第四个）",
		"goods_code" : "LY2234677",
		"goods_barcode" : "LY22346774150",
		"goods_tags_json" : "[\"2019\"]",
		"location_name" : "上海万体馆",
		"size_name" : "xl41",
		"color_name" : "红色50",
		"qty" : 10
	  }, {
		"goods_name" : "0729LY测试商品（第四个）",
		"goods_code" : "LY2234677",
		"goods_barcode" : "LY22346774151",
		"goods_tags_json" : "[\"2019\"]",
		"location_name" : "上海万体馆",
		"size_name" : "xl41",
		"color_name" : "红色51",
		"qty" : 10
	  }, {
		"goods_name" : "0729LY测试商品（第四个）",
		"goods_code" : "LY2234677",
		"goods_barcode" : "LY22346774152",
		"goods_tags_json" : "[\"2019\"]",
		"location_name" : "上海万体馆",
		"size_name" : "xl41",
		"color_name" : "红色52",
		"qty" : 10
	  }, {
		"goods_name" : "0729LY测试商品（第四个）",
		"goods_code" : "LY2234677",
		"goods_barcode" : "LY22346774250",
		"goods_tags_json" : "[\"2019\"]",
		"location_name" : "上海万体馆",
		"size_name" : "xl42",
		"color_name" : "红色50",
		"qty" : 10
	  }, {
		"goods_name" : "0729LY测试商品（第四个）",
		"goods_code" : "LY2234677",
		"goods_barcode" : "LY22346774251",
		"goods_tags_json" : "[\"2019\"]",
		"location_name" : "上海万体馆",
		"size_name" : "xl42",
		"color_name" : "红色51",
		"qty" : 100
	  }, {
		"goods_name" : "0729LY测试商品（第四个）",
		"goods_code" : "LY2234677",
		"goods_barcode" : "LY22346774252",
		"goods_tags_json" : "[\"2019\"]",
		"location_name" : "上海万体馆",
		"size_name" : "xl42",
		"color_name" : "红色52",
		"qty" : 100
	  }, {
		"goods_name" : "0729LY测试商品（第四个）",
		"goods_code" : "LY2234677",
		"goods_barcode" : "2324234231",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : "xxl36",
		"color_name" : "wp红色",
		"qty" : 10
	  }, {
		"goods_name" : "0729LY测试商品（第三个）",
		"goods_code" : "LY8898765",
		"goods_barcode" : "LY88987653635",
		"goods_tags_json" : "[\"2019\"]",
		"location_name" : "上海万体馆",
		"size_name" : "xxl36",
		"color_name" : "红色35",
		"qty" : 10
	  }, {
		"goods_name" : "0729LY测试商品（第三个）",
		"goods_code" : "LY8898765",
		"goods_barcode" : "LY88987653637",
		"goods_tags_json" : "[\"2019\"]",
		"location_name" : "上海万体馆",
		"size_name" : "xxl36",
		"color_name" : "红色37",
		"qty" : 10
	  }, {
		"goods_name" : "0729LY测试商品（第三个）",
		"goods_code" : "LY8898765",
		"goods_barcode" : "LY88987653835",
		"goods_tags_json" : "[\"2019\"]",
		"location_name" : "上海万体馆",
		"size_name" : "xxl38",
		"color_name" : "红色35",
		"qty" : 10
	  }, {
		"goods_name" : "0729LY测试商品（第三个）",
		"goods_code" : "LY8898765",
		"goods_barcode" : "LY88987653837",
		"goods_tags_json" : "[\"2019\"]",
		"location_name" : "上海万体馆",
		"size_name" : "xxl38",
		"color_name" : "红色37",
		"qty" : 10
	  }, {
		"goods_name" : "0729LY测试商品（第三个）",
		"goods_code" : "LY8898765",
		"goods_barcode" : "LY88987654050",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : "xl40",
		"color_name" : "红色50",
		"qty" : 10
	  }, {
		"goods_name" : "0729LY测试商品（第三个）",
		"goods_code" : "LY8898765",
		"goods_barcode" : "LY88987654051",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : "xl40",
		"color_name" : "红色51",
		"qty" : 10
	  }, {
		"goods_name" : "0729LY测试商品（第三个）",
		"goods_code" : "LY8898765",
		"goods_barcode" : "LY88987654052",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : "xl40",
		"color_name" : "红色52",
		"qty" : 10
	  }, {
		"goods_name" : "0729LY测试商品（第三个）",
		"goods_code" : "LY8898765",
		"goods_barcode" : "LY88987654150",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : "xl41",
		"color_name" : "红色50",
		"qty" : 10
	  }, {
		"goods_name" : "0729LY测试商品（第三个）",
		"goods_code" : "LY8898765",
		"goods_barcode" : "LY88987654151",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : "xl41",
		"color_name" : "红色51",
		"qty" : 10
	  }, {
		"goods_name" : "0729LY测试商品（第三个）",
		"goods_code" : "LY8898765",
		"goods_barcode" : "LY88987654152",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : "xl41",
		"color_name" : "红色52",
		"qty" : 10
	  }, {
		"goods_name" : "0729LY测试商品（第三个）",
		"goods_code" : "LY8898765",
		"goods_barcode" : "LY8898765xl50",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : "xl",
		"color_name" : "红色50",
		"qty" : 10
	  }, {
		"goods_name" : "0729LY测试商品（第三个）",
		"goods_code" : "LY8898765",
		"goods_barcode" : "LY8898765xl51",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : "xl",
		"color_name" : "红色51",
		"qty" : 10
	  }, {
		"goods_name" : "0729LY测试商品（第三个）",
		"goods_code" : "LY8898765",
		"goods_barcode" : "LY8898765xl52",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : "xl",
		"color_name" : "红色52",
		"qty" : 10
	  }, {
		"goods_name" : "0729LY测试商品（第二个）",
		"goods_code" : "LY3344999",
		"goods_barcode" : "123456378",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : null,
		"color_name" : null,
		"qty" : 10
	  }, {
		"goods_name" : "0729LY测试商品（第二个）",
		"goods_code" : "LY3344999",
		"goods_barcode" : "LY33449993635",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : "xxl36",
		"color_name" : "红色35",
		"qty" : 10
	  }, {
		"goods_name" : "0729LY测试商品（第二个）",
		"goods_code" : "LY3344999",
		"goods_barcode" : "LY33449993637",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : "xxl36",
		"color_name" : "红色37",
		"qty" : 10
	  }, {
		"goods_name" : "0729LY测试商品（第二个）",
		"goods_code" : "LY3344999",
		"goods_barcode" : "LY334499936998",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : "xxl36",
		"color_name" : "wp红色",
		"qty" : 10
	  }, {
		"goods_name" : "0729LY测试商品（第二个）",
		"goods_code" : "LY3344999",
		"goods_barcode" : "LY33449993835",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : "xxl38",
		"color_name" : "红色35",
		"qty" : 10
	  }, {
		"goods_name" : "0729LY测试商品（第二个）",
		"goods_code" : "LY3344999",
		"goods_barcode" : "LY33449993837",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : "xxl38",
		"color_name" : "红色37",
		"qty" : 10
	  }, {
		"goods_name" : "szr测试3",
		"goods_code" : "987",
		"goods_barcode" : "987X15",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : "X",
		"color_name" : "黑色",
		"qty" : 17
	  }, {
		"goods_name" : "金卡会员射箭",
		"goods_code" : "2342342",
		"goods_barcode" : "234234234234",
		"goods_tags_json" : "[\"2019\"]",
		"location_name" : "上海万体馆",
		"size_name" : null,
		"color_name" : null,
		"qty" : 100
	  }, {
		"goods_name" : "测试添加订单商品",
		"goods_code" : "32311",
		"goods_barcode" : "4123123433",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 10
	  }, {
		"goods_name" : "测试添加订单商品",
		"goods_code" : "32311",
		"goods_barcode" : "4123123433",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : null,
		"color_name" : null,
		"qty" : 99987
	  }, {
		"goods_name" : "快递（其他费用）",
		"goods_code" : "2334",
		"goods_barcode" : "32423423",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : null,
		"color_name" : null,
		"qty" : 2750099
	  }, {
		"goods_name" : "2019新季夏装",
		"goods_code" : "4234324",
		"goods_barcode" : "2342345231",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 150
	  }, {
		"goods_name" : "2019新季夏装",
		"goods_code" : "4234324",
		"goods_barcode" : "2342345231",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : null,
		"color_name" : null,
		"qty" : -120
	  }, {
		"goods_name" : "2019新季夏装",
		"goods_code" : "4234324",
		"goods_barcode" : "42343245",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : null,
		"color_name" : null,
		"qty" : 490
	  }, {
		"goods_name" : "2019新季夏装",
		"goods_code" : "4234324",
		"goods_barcode" : "6923450605288",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 397
	  }, {
		"goods_name" : "2019新季夏装",
		"goods_code" : "4234324",
		"goods_barcode" : "6923450605288",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : null,
		"color_name" : null,
		"qty" : -101
	  }, {
		"goods_name" : "2019新季夏装",
		"goods_code" : "4234324",
		"goods_barcode" : "6928804016970",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 90
	  }, {
		"goods_name" : "2019新季夏装",
		"goods_code" : "4234324",
		"goods_barcode" : "6928804016970",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : null,
		"color_name" : null,
		"qty" : -84
	  }, {
		"goods_name" : "摄氏零度儿童羽绒服",
		"goods_code" : "3242341",
		"goods_barcode" : "32423432215",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 4
	  }, {
		"goods_name" : "摄氏零度儿童羽绒服",
		"goods_code" : "3242341",
		"goods_barcode" : "32423432215",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : null,
		"color_name" : null,
		"qty" : 4
	  }, {
		"goods_name" : "摄氏零度女士羽绒服",
		"goods_code" : "23421",
		"goods_barcode" : "34525234234",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 35
	  }, {
		"goods_name" : "摄氏零度女士羽绒服",
		"goods_code" : "23421",
		"goods_barcode" : "34525234234",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : null,
		"color_name" : null,
		"qty" : -16
	  }, {
		"goods_name" : "摄氏零度男士羽绒服",
		"goods_code" : "12412312",
		"goods_barcode" : "2342342343241",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 0
	  }, {
		"goods_name" : "订单服务费商品",
		"goods_code" : "DD56",
		"goods_barcode" : "242341123123",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 45
	  }, {
		"goods_name" : "彩虹冰淇淋",
		"goods_code" : "L0000Y",
		"goods_barcode" : "2563215A456",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 19
	  }, {
		"goods_name" : "测试货号商品",
		"goods_code" : "12345678",
		"goods_barcode" : "2194827261244",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 0
	  }, {
		"goods_name" : "西瓜",
		"goods_code" : "SY84506711",
		"goods_barcode" : "WC1256789",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 0
	  }, {
		"goods_name" : "冰凉凉",
		"goods_code" : "LY512545",
		"goods_barcode" : "LY24524523",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 35
	  }, {
		"goods_name" : "摄氏零度测试产品",
		"goods_code" : "462",
		"goods_barcode" : "532342342223",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 5
	  }, {
		"goods_name" : "20180626测试",
		"goods_code" : "120",
		"goods_barcode" : "42342342334",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : null,
		"color_name" : null,
		"qty" : 65
	  }, {
		"goods_name" : "鼠标",
		"goods_code" : "1122",
		"goods_barcode" : "6678886678244",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : null,
		"color_name" : null,
		"qty" : 0
	  }, {
		"goods_name" : "苏泊尔电饭煲CFXB50YB7A-70",
		"goods_code" : "102175",
		"goods_barcode" : "6950609400067",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 14
	  }, {
		"goods_name" : "苏泊尔电磁炉SDHC15-210",
		"goods_code" : "102002",
		"goods_barcode" : "6950610200878",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 1
	  }, {
		"goods_name" : "苏泊尔电饭煲CFXB40FC11N-75",
		"goods_code" : "102166",
		"goods_barcode" : "6950609400333",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 142
	  }, {
		"goods_name" : "Synology DS918+",
		"goods_code" : "0002",
		"goods_barcode" : "002",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 14
	  }, {
		"goods_name" : "Synology DS918+",
		"goods_code" : "0002",
		"goods_barcode" : "002",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : null,
		"color_name" : null,
		"qty" : 0.0
	  }, {
		"goods_name" : "温雅发采染发局油 ( 浅棕红 )50ML",
		"goods_code" : "10025",
		"goods_barcode" : "6920619197844",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 1
	  }, {
		"goods_name" : "多力Omega3食用调和油",
		"goods_code" : "100489",
		"goods_barcode" : "6909931282117",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 16
	  }, {
		"goods_name" : "男式绒布睡",
		"goods_code" : "100753",
		"goods_barcode" : "6930968112184",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 13
	  }, {
		"goods_name" : "W13-MAN-NIG0001 粉格 L 男式绒布睡衣",
		"goods_code" : "100750",
		"goods_barcode" : "6930968112160",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : "粉色",
		"qty" : 14
	  }, {
		"goods_name" : "立白生姜洗洁精1.5KG",
		"goods_code" : "100117",
		"goods_barcode" : "6920174762921",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 13
	  }, {
		"goods_name" : "酷奇超值装清洁套装",
		"goods_code" : "100090",
		"goods_barcode" : "6945008430074",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 15
	  }, {
		"goods_name" : "女式休闲羊皮手套",
		"goods_code" : "100050",
		"goods_barcode" : "2040001000508",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 146
	  }, {
		"goods_name" : "艾蒙多720ML时尚单层不锈钢运动水甁",
		"goods_code" : "100039",
		"goods_barcode" : "6953786013013",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 1
	  }, {
		"goods_name" : "Imac",
		"goods_code" : "2001",
		"goods_barcode" : "12344321",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 134
	  }, {
		"goods_name" : "ZY 715 男 PU 系带正装鞋 39",
		"goods_code" : "00001",
		"goods_barcode" : "21234646448949465",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 1
	  }, {
		"goods_name" : "Synology DS916+",
		"goods_code" : "10001",
		"goods_barcode" : "111111",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 16
	  }, {
		"goods_name" : "Synology DS916+",
		"goods_code" : "10001",
		"goods_barcode" : "111111",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : null,
		"color_name" : null,
		"qty" : -2.0
	  }, {
		"goods_name" : "意可可吸盘牙刷架套装",
		"goods_code" : "8662",
		"goods_barcode" : "11223",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 15
	  }, {
		"goods_name" : "意可可吸盘牙刷架套装",
		"goods_code" : "8662",
		"goods_barcode" : "780085578233",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 1
	  }, {
		"goods_name" : "洁柔face餐巾纸120抽*1包",
		"goods_code" : "098233",
		"goods_barcode" : "69093467224",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 134
	  }, {
		"goods_name" : "EIN/言英伦格子女士风衣女中长款韩版复古",
		"goods_code" : "9878233",
		"goods_barcode" : "68967668223",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 1
	  }, {
		"goods_name" : "EIN/言英伦格子女士风衣女中长款韩版复古",
		"goods_code" : "9878233",
		"goods_barcode" : "68967668223",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : null,
		"color_name" : null,
		"qty" : 5
	  }, {
		"goods_name" : "Five Plus秋装条纹系带长袖圆领套头毛衣",
		"goods_code" : "272784",
		"goods_barcode" : "231564897654",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : "上衣",
		"color_name" : "红色",
		"qty" : 13
	  }, {
		"goods_name" : "Five Plus秋装条纹系带长袖圆领套头毛衣",
		"goods_code" : "272784",
		"goods_barcode" : "231564897655",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : "上衣",
		"color_name" : "红色",
		"qty" : 16
	  }, {
		"goods_name" : "Five Plus秋装条纹系带长袖圆领套头毛衣",
		"goods_code" : "272784",
		"goods_barcode" : "231564897656",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : "上衣",
		"color_name" : "红色",
		"qty" : 1
	  }, {
		"goods_name" : "Five Plus秋装条纹系带长袖圆领套头毛衣",
		"goods_code" : "272784",
		"goods_barcode" : "231564897660",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : "上衣",
		"color_name" : "黑色",
		"qty" : 142
	  }, {
		"goods_name" : "Five Plus秋装条纹系带长袖圆领套头毛衣",
		"goods_code" : "272784",
		"goods_barcode" : "231564897661",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : "上衣",
		"color_name" : "黑色",
		"qty" : 1364
	  }, {
		"goods_name" : "Five Plus秋装条纹系带长袖圆领套头毛衣",
		"goods_code" : "272784",
		"goods_barcode" : "231564897670",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : "服装",
		"color_name" : "蓝色",
		"qty" : 14
	  }, {
		"goods_name" : "春秋冬季气质针织裙子两件套时chic风",
		"goods_code" : "108",
		"goods_barcode" : "690988892234",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : "服装",
		"color_name" : "米色",
		"qty" : 14
	  }, {
		"goods_name" : "春秋冬季气质针织裙子两件套时chic风",
		"goods_code" : "108",
		"goods_barcode" : "690988892235",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : "服装",
		"color_name" : "绿色",
		"qty" : 1
	  }, {
		"goods_name" : "洁柔face餐巾纸120抽*12包",
		"goods_code" : "233",
		"goods_barcode" : "98099766223",
		"goods_tags_json" : "[\"1998年\"]",
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 167
	  }, {
		"goods_name" : "风衣女休闲长袖学生长款过膝外套女",
		"goods_code" : "6786293",
		"goods_barcode" : "9876902233",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 17
	  }, {
		"goods_name" : "宽松原宿风卫衣女丝绒大红色套头连帽喇叭袖外套",
		"goods_code" : "9076892",
		"goods_barcode" : "8657299330722",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 18
	  }, {
		"goods_name" : "宽松原宿风卫衣女丝绒大红色套头连帽喇叭袖外套",
		"goods_code" : "9076892",
		"goods_barcode" : "8657299330772",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 1
	  }, {
		"goods_name" : "D－PLAY欧美白色镂空A字裙无袖中长连衣裙礼服裙",
		"goods_code" : "7682233",
		"goods_barcode" : "765689222334",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 1876
	  }, {
		"goods_name" : "D－PLAY欧美白色镂空A字裙无袖中长连衣裙礼服裙",
		"goods_code" : "7682233",
		"goods_barcode" : "9688865523325",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 178
	  }, {
		"goods_name" : "D－PLAY红色长裙",
		"goods_code" : "938742",
		"goods_barcode" : "1231231231232",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : "上衣",
		"color_name" : null,
		"qty" : 17
	  }, {
		"goods_name" : "D－PLAY红色长裙",
		"goods_code" : "938742",
		"goods_barcode" : "1234123412344",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : "上衣",
		"color_name" : null,
		"qty" : 17
	  }, {
		"goods_name" : "D－PLAY红色长裙",
		"goods_code" : "938742",
		"goods_barcode" : "8556992334423",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : "大码",
		"color_name" : null,
		"qty" : 14
	  }, {
		"goods_name" : "自动扣皮带男真皮腰带H商务150",
		"goods_code" : "387672",
		"goods_barcode" : "8556890097722",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 15
	  }, {
		"goods_name" : "条纹男女情侣装混纺毛衣针织衫",
		"goods_code" : "3678223",
		"goods_barcode" : "75578902231",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : "小号",
		"color_name" : "蓝色",
		"qty" : 1
	  }, {
		"goods_name" : "条纹男女情侣装混纺毛衣针织衫",
		"goods_code" : "3678223",
		"goods_barcode" : "75578902232",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : "大码",
		"color_name" : "蓝色",
		"qty" : 145
	  }, {
		"goods_name" : "条纹男女情侣装混纺毛衣针织衫",
		"goods_code" : "3678223",
		"goods_barcode" : "75578902233",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : "大码",
		"color_name" : "红色",
		"qty" : 16
	  }, {
		"goods_name" : "格子7七分裤加肥加大码直筒潮胖青年沙滩日系",
		"goods_code" : "387984",
		"goods_barcode" : "8656892865332",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : "大码",
		"color_name" : "红色",
		"qty" : 15
	  }, {
		"goods_name" : "男士牛仔长裤 英伦风",
		"goods_code" : "3679922",
		"goods_barcode" : "9866790223309",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : "上衣",
		"color_name" : "紫色",
		"qty" : 123
	  }, {
		"goods_name" : "男士牛仔长裤 英伦风",
		"goods_code" : "3679922",
		"goods_barcode" : "9866790223316",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : "上衣",
		"color_name" : "紫色",
		"qty" : 13
	  }, {
		"goods_name" : "男士牛仔长裤 英伦风",
		"goods_code" : "3679922",
		"goods_barcode" : "9866790223330",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : "上衣",
		"color_name" : "紫色",
		"qty" : 1
	  }, {
		"goods_name" : "男士牛仔长裤 英伦风",
		"goods_code" : "3679922",
		"goods_barcode" : "98667902233333",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : "上衣",
		"color_name" : "红色",
		"qty" : 1
	  }, {
		"goods_name" : "青年牛仔裤男修身型小脚裤",
		"goods_code" : "3678922",
		"goods_barcode" : "17996679",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : "上衣",
		"color_name" : "蓝色",
		"qty" : 15
	  }, {
		"goods_name" : "青年牛仔裤男修身型小脚裤",
		"goods_code" : "3678922",
		"goods_barcode" : "678992663322",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : "大码",
		"color_name" : "红色",
		"qty" : 168
	  }, {
		"goods_name" : "青年牛仔裤男修身型小脚裤",
		"goods_code" : "3678922",
		"goods_barcode" : "6900866223329",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : "上衣",
		"color_name" : "白色",
		"qty" : 1
	  }, {
		"goods_name" : "青年牛仔裤男修身型小脚裤",
		"goods_code" : "3678922",
		"goods_barcode" : "6900876722447",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : "上衣",
		"color_name" : "白色",
		"qty" : 15
	  }, {
		"goods_name" : "秋季休闲西装",
		"goods_code" : "368000",
		"goods_barcode" : "7558992223",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : "X",
		"color_name" : "紫色",
		"qty" : 19
	  }, {
		"goods_name" : "咖啡机",
		"goods_code" : "20093",
		"goods_barcode" : "0998801122",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 10
	  }, {
		"goods_name" : "柠檬",
		"goods_code" : "25013",
		"goods_barcode" : "8677892244553",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 17
	  }, {
		"goods_name" : "海之言 柠檬口味 整箱装",
		"goods_code" : "1113",
		"goods_barcode" : "9783712490128",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 15
	  }, {
		"goods_name" : "七喜碳酸饮料",
		"goods_code" : "1112",
		"goods_barcode" : "34435211466",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 13
	  }, {
		"goods_name" : "雪碧碳酸饮料整箱",
		"goods_code" : "1111",
		"goods_barcode" : "3242352312385",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 10
	  }, {
		"goods_name" : "雪碧碳酸饮料整箱",
		"goods_code" : "1111",
		"goods_barcode" : "6908512109218",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 15
	  }, {
		"goods_name" : "DGI 低GI无添糖粗粮饼干",
		"goods_code" : "113",
		"goods_barcode" : "69464552342",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 1
	  }, {
		"goods_name" : "良品铺子零食大礼包组合",
		"goods_code" : "112",
		"goods_barcode" : "9723489623",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 16
	  }, {
		"goods_name" : "Monster Energy 猛事特红牛",
		"goods_code" : "111",
		"goods_barcode" : "6985634324",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 25
	  }, {
		"goods_name" : "进口The Laundress婴儿专业洗衣液",
		"goods_code" : "104",
		"goods_barcode" : "9876424222",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 1
	  }, {
		"goods_name" : "进口 Nutrovape 咖啡因能量棒",
		"goods_code" : "103",
		"goods_barcode" : "9792194412",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 167
	  }, {
		"goods_name" : "四洛克断片酒3罐",
		"goods_code" : "25001",
		"goods_barcode" : "423536234",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 151.0
	  }, {
		"goods_name" : "菠萝",
		"goods_code" : "25015",
		"goods_barcode" : "1412442451",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 9
	  }, {
		"goods_name" : "菠萝",
		"goods_code" : "25015",
		"goods_barcode" : "1412442451",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : null,
		"color_name" : null,
		"qty" : 8
	  }, {
		"goods_name" : "菠萝",
		"goods_code" : "25015",
		"goods_barcode" : "40452452241",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 12
	  }, {
		"goods_name" : "菠萝",
		"goods_code" : "25015",
		"goods_barcode" : "40452452241",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : null,
		"color_name" : null,
		"qty" : 9
	  }, {
		"goods_name" : "菠萝",
		"goods_code" : "25015",
		"goods_barcode" : "42422634142",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 1
	  }, {
		"goods_name" : "菠萝",
		"goods_code" : "25015",
		"goods_barcode" : "42422634142",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : null,
		"color_name" : null,
		"qty" : 10
	  }, {
		"goods_name" : "菠萝",
		"goods_code" : "25015",
		"goods_barcode" : "4654816498",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 15
	  }, {
		"goods_name" : "菠萝",
		"goods_code" : "25015",
		"goods_barcode" : "4654816498",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : null,
		"color_name" : null,
		"qty" : 10
	  }, {
		"goods_name" : "葡萄",
		"goods_code" : "010",
		"goods_barcode" : "6699962563216",
		"goods_tags_json" : "[\"好吃\",\"好看\"]",
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 15
	  }, {
		"goods_name" : "葡萄",
		"goods_code" : "010",
		"goods_barcode" : "6699962563216",
		"goods_tags_json" : "[\"好吃\",\"好看\"]",
		"location_name" : "上海万体馆",
		"size_name" : null,
		"color_name" : null,
		"qty" : 10
	  }, {
		"goods_name" : "葡萄",
		"goods_code" : "010",
		"goods_barcode" : "126565661",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 165
	  }, {
		"goods_name" : "葡萄",
		"goods_code" : "010",
		"goods_barcode" : "126565661",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : null,
		"color_name" : null,
		"qty" : 10
	  }, {
		"goods_name" : "葡萄",
		"goods_code" : "010",
		"goods_barcode" : "566619816",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 2.0
	  }, {
		"goods_name" : "葡萄",
		"goods_code" : "010",
		"goods_barcode" : "566619816",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : null,
		"color_name" : null,
		"qty" : 10
	  }, {
		"goods_name" : "机械革命(MECHREVO)游戏笔记本",
		"goods_code" : "012",
		"goods_barcode" : "456789123321",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 0
	  }, {
		"goods_name" : "机械革命(MECHREVO)游戏笔记本",
		"goods_code" : "012",
		"goods_barcode" : "456789123321",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : null,
		"color_name" : null,
		"qty" : 0
	  }, {
		"goods_name" : "宏碁15.6英寸游戏笔记本",
		"goods_code" : "013",
		"goods_barcode" : "697778334",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 179
	  }, {
		"goods_name" : "宏碁15.6英寸游戏笔记本",
		"goods_code" : "013",
		"goods_barcode" : "697778334",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : null,
		"color_name" : null,
		"qty" : -1.0
	  }, {
		"goods_name" : "Apple MacBook Pro 13.3英寸笔记本电脑",
		"goods_code" : "011",
		"goods_barcode" : "334422342123",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 154
	  }, {
		"goods_name" : "Apple MacBook Pro 13.3英寸笔记本电脑",
		"goods_code" : "011",
		"goods_barcode" : "334422342123",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : null,
		"color_name" : null,
		"qty" : -4
	  }, {
		"goods_name" : "蒙牛 纯甄 常温酸牛奶",
		"goods_code" : "014",
		"goods_barcode" : "12344555334",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 261.0
	  }, {
		"goods_name" : "蒙牛 纯甄 常温酸牛奶",
		"goods_code" : "014",
		"goods_barcode" : "12344555334",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : null,
		"color_name" : null,
		"qty" : 100000.0
	  }, {
		"goods_name" : "雀巢Nestle醇品速溶咖",
		"goods_code" : "015",
		"goods_barcode" : "6900882223441",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 24.0
	  }, {
		"goods_name" : "雀巢Nestle醇品速溶咖",
		"goods_code" : "015",
		"goods_barcode" : "6900882223441",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : null,
		"color_name" : null,
		"qty" : 9978
	  }, {
		"goods_name" : "维他 低糖柠檬茶250ml*16盒",
		"goods_code" : "016",
		"goods_barcode" : "690123634105612",
		"goods_tags_json" : "[\"123\"]",
		"location_name" : "A仓库",
		"size_name" : "服装",
		"color_name" : "绿色",
		"qty" : 19
	  }, {
		"goods_name" : "维他 低糖柠檬茶250ml*16盒",
		"goods_code" : "016",
		"goods_barcode" : "690123634105612",
		"goods_tags_json" : "[\"123\"]",
		"location_name" : "上海万体馆",
		"size_name" : "服装",
		"color_name" : "绿色",
		"qty" : -4
	  }, {
		"goods_name" : "维他 低糖柠檬茶250ml*16盒",
		"goods_code" : "016",
		"goods_barcode" : "6901234578935",
		"goods_tags_json" : "[\"123\",\"456\",\"789\",\"1234\",\"4567\",\"6789\",\"12345\",\"67890\",\"1234567890\",\"weita\",\"fruit\",\"维他茶\",\"柠檬茶\",\"茶\",\"巴适\"]",
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 173
	  }, {
		"goods_name" : "维他 低糖柠檬茶250ml*16盒",
		"goods_code" : "016",
		"goods_barcode" : "6901234578935",
		"goods_tags_json" : "[\"123\",\"456\",\"789\",\"1234\",\"4567\",\"6789\",\"12345\",\"67890\",\"1234567890\",\"weita\",\"fruit\",\"维他茶\",\"柠檬茶\",\"茶\",\"巴适\"]",
		"location_name" : "上海万体馆",
		"size_name" : null,
		"color_name" : null,
		"qty" : -1
	  }, {
		"goods_name" : "维他 低糖柠檬茶250ml*16盒",
		"goods_code" : "016",
		"goods_barcode" : "690123633105612",
		"goods_tags_json" : "[\"1992年\",\"夏\"]",
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 10.0
	  }, {
		"goods_name" : "维他 低糖柠檬茶250ml*16盒",
		"goods_code" : "016",
		"goods_barcode" : "690123633105612",
		"goods_tags_json" : "[\"1992年\",\"夏\"]",
		"location_name" : "上海万体馆",
		"size_name" : null,
		"color_name" : null,
		"qty" : 1.0
	  }, {
		"goods_name" : "维他 低糖柠檬茶250ml*16盒",
		"goods_code" : "016",
		"goods_barcode" : "690123634105611",
		"goods_tags_json" : "[\"1998年\"]",
		"location_name" : "A仓库",
		"size_name" : "服装",
		"color_name" : "米色",
		"qty" : 14.0
	  }, {
		"goods_name" : "维他 低糖柠檬茶250ml*16盒",
		"goods_code" : "016",
		"goods_barcode" : "690123634105611",
		"goods_tags_json" : "[\"1998年\"]",
		"location_name" : "上海万体馆",
		"size_name" : "服装",
		"color_name" : "米色",
		"qty" : -1
	  }, {
		"goods_name" : "维他 低糖柠檬茶250ml*16盒",
		"goods_code" : "016",
		"goods_barcode" : "69008822234411",
		"goods_tags_json" : null,
		"location_name" : "A仓库",
		"size_name" : null,
		"color_name" : null,
		"qty" : 32
	  }, {
		"goods_name" : "维他 低糖柠檬茶250ml*16盒",
		"goods_code" : "016",
		"goods_barcode" : "69008822234411",
		"goods_tags_json" : null,
		"location_name" : "上海万体馆",
		"size_name" : null,
		"color_name" : null,
		"qty" : 1
	  } ]
}



// WEBPACK FOOTER //
// ./src/assets/plugins/hiprint/custom_test/print-data.js